import { IAppliedFilter } from "@/app/models/auctor"
import { evaluateExpressionWithFiltersAndRowData } from "@/app/utils/expression-utils"
import dynamic from "next/dynamic"
const GaugeComponent = dynamic(() => import("react-gauge-component"))

interface IGaugeBlockProps {
    block: any
    expressionContext?: string
    appliedFilters: IAppliedFilter[]
    toolData: any
    queryParams?: Record<string, string> | null
}

export default function GaugeBlock({
    block,
    expressionContext,
    appliedFilters,
    toolData,
    queryParams,
}: IGaugeBlockProps) {
    let gaugeValue = evaluateExpressionWithFiltersAndRowData(
        block.expression_value,
        toolData,
        appliedFilters,
        expressionContext,
        queryParams
    )

    if (isNaN(gaugeValue) || gaugeValue < block.min_gauge_value) {
        gaugeValue = block.min_gauge_value
    }

    if (gaugeValue > block.max_gauge_value) {
        gaugeValue = block.max_gauge_value
    }

    const arcProps = {
        width: 0.27,
        subArcs: [
            {
                limit: gaugeValue,
                color: "#65cb65",
                showTick: false,
            },
            { color: "#f25b5b" },
        ],
        cornerRadius: 0,
        padding: 0.005,
        showTicks: false,
    }

    const pointerProps = {
        type: "needle" as const,
        width: 7,
        length: 0.95,
        color: "#fff",
        animate: false,
        animationDuration: 500,
        elastic: false,
    }

    const labelsProps = {
        valueLabel: {
            style: {
                position: "relative" as const,
                top: "50px",
                fill: "#fff",
                fontSize: "50px",
                fontWeight: "700",
                textShadow: "none",
                transform: "translate(0%, 40%)",
            },
            hide: true,
        },
        tickLabels: {
            ticks: [],
            defaultTickValueConfig: {
                distanceFromArc: 0,
                hide: true,
            },
            defaultTickLineConfig: {
                hide: true,
            },
        },
    }

    return (
        <div
            className={
                "flex flex-col justify-center items-center gap-2 relative min-h-[140px] min-w-[140px] bg-black/50 rounded-full"
            }
        >
            <GaugeComponent
                type="semicircle"
                minValue={block.min_gauge_value}
                maxValue={block.max_gauge_value}
                value={gaugeValue}
                arc={arcProps}
                style={{ width: "140px", height: "140px", borderRadius: "50%" }}
                marginInPercent={{ top: 0.04, bottom: 0.0, left: 0.14, right: 0.14 }}
                pointer={pointerProps}
                labels={labelsProps}
            />
            <span className="text-4xl text-white font-semibold absolute bottom-6 whitespace-nowrap">
                {gaugeValue} {block.value_suffix}
            </span>
        </div>
    )
}
